/**
 * Email API Module
 * Методы для управления email адресами: смена, верификация
 * 
 * @typedef {import('./types').ChangeEmailRequest} ChangeEmailRequest
 * @typedef {import('./types').ChangeEmailResponse} ChangeEmailResponse
 * @typedef {import('./types').VerifyEmailChangeRequest} VerifyEmailChangeRequest
 * @typedef {import('./types').VerifyEmailChangeResponse} VerifyEmailChangeResponse
 */

import { authFetch } from '../authClient';

/**
 * POST /api/auth/users/me/email
 * Запрос на смену email адреса (отправляет код подтверждения)
 * @param {ChangeEmailRequest} data
 * @returns {Promise<ChangeEmailResponse>}
 */
export async function requestEmailChange(data) {
  return authFetch('/api/auth/users/me/email', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

/**
 * POST /api/auth/users/me/email/verify
 * Подтверждение смены email по коду подтверждения
 * @param {VerifyEmailChangeRequest} data
 * @returns {Promise<VerifyEmailChangeResponse>}
 */
export async function verifyEmailChange(data) {
  return authFetch('/api/auth/users/me/email/verify', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}
